var _ellipse, _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconConnections(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.73368,
    cy: 9.06669,
    rx: 3.73368,
    ry: 3.73368,
    fill: "#F75151"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.6658,
    cy: 2.13353,
    r: 2.13353,
    fill: "#F75151"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3329,
    cy: 13.3354,
    r: 2.66691,
    fill: "#F75151"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1353 2.66748L4.26807 8.53469L13.869 13.3351",
    stroke: "#F75151"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConnections);
export default __webpack_public_path__ + "static/media/icon_connections.1c4cb49f401a1bc364b11a60fa294c86.svg";
export { ForwardRef as ReactComponent };